import React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
var hideLabelsFor = {
  "addRuleGroup": true,
  "addRuleGroupExt": true,
  "delGroup": true,
  "delRuleGroup": true,
  "delRule": true
};
var typeToColor = {
  "addRule": "primary",
  "addGroup": "primary",
  "delGroup": "secondary",
  "delRuleGroup": "secondary",
  "delRule": "secondary"
};
export default (function (props) {
  var type = props.type,
    label = props.label,
    onClick = props.onClick,
    readonly = props.readonly,
    renderIcon = props.renderIcon;
  var iconProps = {
    type: type,
    readonly: readonly
  };
  var icon = renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon(iconProps);
  if (!label || hideLabelsFor[type]) {
    return /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      disabled: readonly,
      onClick: onClick,
      color: typeToColor[type]
    }, icon);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      size: "small",
      disabled: readonly,
      onClick: onClick,
      color: typeToColor[type],
      startIcon: icon
    }, label);
  }
});